import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ViewChild } from "@angular/core";
//import { Pause } from "./pause.model";
import { PauseService } from "../services/pause.service";
import { ToasterService } from "angular2-toaster";
import { FormGroup } from "@angular/forms";
import { FormGeneratorService } from '@ngx-resource-toolkit/core';
import { PauseModel } from "../../cours/models/pause.model";
import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";


@Component({
    selector: 'pause-form',
    templateUrl: './pause.component.html',
})

export class PauseComponent implements OnInit {
    @Input() pause: PauseModel;
    @Input() isModal: boolean = true;
    public form: FormGroup;
    @Input() mode: string;

    horaireDebutHeure: string;
    horaireFinHeure: string;
    @Output() saved = new EventEmitter<any>();
    @Output() cancel = new EventEmitter<any>();
    @ViewChild('modal') modal: any;

  jours = [
    { value: '1', label: 'Lundi' },
    { value: '2', label: 'Mardi' },
    { value: '3', label: 'Mercredi' },
    { value: '4', label: 'Jeudi' },
    { value: '5', label: 'Vendredi' },
    { value: '6', label: 'Samedi' },
    { value: '7', label: 'Dimanche' },
  ];

  constructor(
    private pauseService: PauseService,
    private toaster: ToasterService,
    private formGenerator: FormGeneratorService,
    private http: HttpClient,
) {}
  ngOnInit(): void {
    if (this.pause) {
      this.pause.duree = +this.pause.duree; // Convertit en nombre
      this.pause.jour = this.pause.jour.toString(); // Assure que c'est une chaîne
    }
    this.form = this.formGenerator.createFormGroup(this.pause, 'edit');
  }
ngOnChanges(changes: SimpleChanges) {
  console.log('Pause reçu :', this.pause);
  if (changes.pause) {
    this.updateHeureValues();
  }
}
updateHeureValues() {
        this.horaireDebutHeure = this.toHeure(this.pause.horaireDebut);
        this.horaireFinHeure = this.toHeure(this.pause.horaireFin);
}
onHoraireDebutChange(newHoraireDebut: string) {
    console.log('onHoraireDebutChange', newHoraireDebut)
        this.pause.horaireDebut = this.toMinutes(newHoraireDebut);
        // Peut-être remplir la propriété ce cette façon : 
        //this.model.registerEntryDynamicProperty(['edit'], 'bool_02', 'hidden', false);
        this.updateHoraireFin(); // Recalcule l'horaire de fin
        this.horaireDebutHeure = newHoraireDebut;  // Mise à jour de la valeur affichée
}
onHoraireFinChange(newHoraireFin: string) {
        this.pause.horaireFin = this.toMinutes(newHoraireFin);
        this.updateHoraireDebut();
        this.horaireFinHeure = newHoraireFin; // Mise à jour de la valeur affichée
}
onDureeChange() {
        this.updateHoraireFin(); // Recalcule l'horaire de fin
}
updateHoraireFin() {
        if (this.pause.horaireDebut && this.pause.duree) {
            this.pause.horaireFin = +this.pause.horaireDebut + +this.pause.duree;
            this.horaireFinHeure = this.toHeure(this.pause.horaireFin); // Mise à jour de la valeur affichée
        }
}
updateHoraireDebut() {
        if (this.pause.horaireFin && this.pause.duree) {
            this.pause.horaireDebut = this.pause.horaireFin - this.pause.duree;
            this.horaireDebutHeure = this.toHeure(this.pause.horaireDebut); // Mise à jour de la valeur affichée
        }
}
  toHeure(minutes: number | string): string {
    console.log('toHeure input:', minutes);
    if (minutes === undefined || minutes === null) {
        return '00:00';
    }
    const min = +minutes;
    const h = Math.floor(min / 60);
    const m = min % 60;
    const result = `${this.pad(h)}:${this.pad(m)}`;
    console.log('toHeure output:', result);
    return result;
  }

  toMinutes(heure: string): number {
    if (!heure) return 0;
    const [h, m] = heure.split(':').map(Number);
    console.log('toMinutes', h, m);
    return h * 60 + m;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }

  onCancel() {
    this.cancel.emit(); // Émettez l'événement cancel
    this.modal.close();
  }

  save() {
    console.log({pause: this.pause})
    const pause = {
      ...this.pause,
      horaireDebut: this.pause.horaireDebut, //this.toMinutes(this.pause.horaireDebut),
      horaireFin: +this.pause.horaireDebut+this.pause.duree,
    };
    const pauseModel: PauseModel = new PauseModel(pause);
    console.log({pause, pauseModel})
    const pauseToSend: FormGroup = this.formGenerator.createFormGroup(pauseModel, 'edit');
    console.log('TODO enregistrer pause', pauseToSend)
    /*this.pauseService.save(pauseToSend).subscribe((data) => {
                console.log('Pause enregistrée :', data);
                this.toaster.pop('success', 'Succès', 'La pause a été enregistrée');
                this.saved.emit(data);
            },
            (err) => {
                console.error('Erreur lors de l\'enregistrement de la pause :', err);
                this.toaster.pop('error', 'Erreur', 'L\'enregistrement de la pause a échoué');
            });        
    */

        //let pause = pauseToSend.value;
        const dataToSend = [pause]; // anneeScolaire en 2ème paramètre
        const request = pause.id 
          ? this.http.patch(environment.proxyUrl + '/pause/', dataToSend)
          : this.http.post(environment.proxyUrl + '/pause/', dataToSend);
        request.subscribe(data => {
          console.log(data);
            this.toaster.pop('info', 'La pause a été enregistrée');
            //this.loadData();
            //this.edit.close();
            this.saved.emit(data);
        }, (err) => {
          console.log('Enregistrement pause en erreur', err);
          this.toaster.pop('error', 'Erreur lors de l\'enregistrement de la pause');
        }
        );
  }
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/cours/pause.component.ts